import React from "react";

const map = () => {
  return (
    <div className=" col-md-8 col-sm-8 col-xs-12 contact-map">
      <div className="map-grid">
        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31785.51159108822!2d119.5070736536584!3d-5.232990495891065!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dbee13639154f11%3A0x77d363f632d6f859!2sUniversitas%20Hasanuddin%20Kampus%20FAKULTAS%20TEKNIK%20Gowa!5e0!3m2!1sen!2sus!4v1643897741885!5m2!1sen!2sus"
          width="600"
          height="450"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};
export default map;
